import React, { useState } from 'react';
import { isOffstationLocationMasked, maskOffstationLocation } from './militaryOptions';

export default function OffstationLocationDisplay({
  value,
  emptyLabel = 'Offstation location needed',
  className = '',
}) {
  const [showNote, setShowNote] = useState(false);
  const masked = isOffstationLocationMasked(value);
  const label = maskOffstationLocation(value, emptyLabel);

  if (!masked) return label;

  return (
    <span className={['offstation-location-mask', className].filter(Boolean).join(' ')}>
      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
          setShowNote(current => !current);
        }}
        title="Show OPSEC masking note"
      >
        {label}
      </button>
      {showNote ? <small role="status">Masked for OPSEC purposes.</small> : null}
    </span>
  );
}
